<div class="dashboard-page">
    <div class="title-page d-flex justify-content-between">
        <div class="title">
            Thêm Mới Nhân Viên
        </div>
        <BreadcrumbComponent></BreadcrumbComponent>
    </div>
    <div style="background: #f7f8f9;height: 100%">
        <div class="container-fluid">
            <div class="card">
                <div class="card-body">
                    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="errorMessage !== undefined && errorMessage.length > 0" v-for="(error, key) in errorMessage" :key="error">
                        <span>{{error}}</span>
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="removeError(key)">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="list-partners-component">
                        <div class="col-sm-12 d-flex gap-3 flex-wrap align-content-center flex-column align-items-center">
                            <div class="col-sm-4">
                                <InputTextNormal
                                        :label="dataRegister.user_name.label"
                                        :id="dataRegister.user_name.id"
                                        :placeholder="dataRegister.user_name.placeholder"
                                        :value-default="dataRegister.user_name.value"
                                        @inputValue="onChange($event, dataRegister.user_name.id)"
                                        :error-text="dataRegister.user_name.error"
                                        :is-error="dataRegister.user_name.isError"
                                        @blur="validateForm($event, dataRegister.user_name.id)"
                                        :required="dataRegister.user_name.required"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-4">
                                <SelectNormal
                                        :label="dataRegister.employer_role.label"
                                        :id="dataRegister.employer_role.id"
                                        :placeholder="dataRegister.employer_role.placeholder"
                                        :value-default="dataRegister.employer_role.value"
                                        :options="dataRegister.employer_role.options"
                                        @inputValue="onChange($event, dataRegister.employer_role.id)"
                                        @blur="validateForm($event, dataRegister.employer_role.id)"
                                        :error-text="dataRegister.employer_role.error"
                                        :is-error="dataRegister.employer_role.isError"
                                        :required="dataRegister.employer_role.required"
                                ></SelectNormal>
                            </div>

                            <div class="col-sm-4">
                                <SelectNormal
                                        :label="dataRegister.store_id.label"
                                        :id="dataRegister.store_id.id"
                                        :placeholder="dataRegister.store_id.placeholder"
                                        :value-default="dataRegister.store_id.value"
                                        :options="dataRegister.store_id.options"
                                        @inputValue="onChange($event, dataRegister.store_id.id)"
                                        :error-text="dataRegister.store_id.error"
                                        :is-error="dataRegister.store_id.isError"
                                ></SelectNormal>
                            </div>

                            <div class="col-sm-4">
                                <InputTextNormal
                                        :label="dataRegister.user_phone.label"
                                        :id="dataRegister.user_phone.id"
                                        :placeholder="dataRegister.user_phone.placeholder"
                                        :value-default="dataRegister.user_phone.value"
                                        @inputValue="onChange($event, dataRegister.user_phone.id)"
                                        :error-text="dataRegister.user_phone.error"
                                        :is-error="dataRegister.user_phone.isError"
                                        @blur="validateForm($event, dataRegister.user_phone.id)"
                                        :required="dataRegister.user_phone.required"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-4">
                                <InputTextNormal
                                        :label="dataRegister.user_email.label"
                                        :id="dataRegister.user_email.id"
                                        :placeholder="dataRegister.user_email.placeholder"
                                        :value-default="dataRegister.user_email.value"
                                        @inputValue="onChange($event, dataRegister.user_email.id)"
                                        :error-text="dataRegister.user_email.error"
                                        :is-error="dataRegister.user_email.isError"
                                        @blur="validateForm($event, dataRegister.user_email.id)"
                                        :required="dataRegister.user_email.required"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-4">
                                <SelectNormal
                                        :label="dataRegister.user_gender.label"
                                        :id="dataRegister.user_gender.id"
                                        :placeholder="dataRegister.user_gender.placeholder"
                                        :value-default="dataRegister.user_gender.value"
                                        :options="dataRegister.user_gender.options"
                                        @inputValue="onChange($event, dataRegister.user_gender.id)"
                                        :error-text="dataRegister.user_gender.error"
                                        :is-error="dataRegister.user_gender.isError"
                                        @blur="validateForm($event, dataRegister.user_gender.id)"
                                        :required="dataRegister.user_gender.required"
                                ></SelectNormal>
                            </div>

                            <div class="col-sm-4">
                                <InputDateTimeNormal
                                        :label="dataRegister.user_birthday.label"
                                        :id="dataRegister.user_birthday.id"
                                        :placeholder="dataRegister.user_birthday.placeholder"
                                        :value-default="dataRegister.user_birthday.value"
                                        @inputValue="onChange($event, dataRegister.user_birthday.id)"
                                        :error-text="dataRegister.user_birthday.error"
                                        :is-error="dataRegister.user_birthday.isError"
                                        @blur="validateForm($event, dataRegister.user_birthday.id)"
                                        :required="dataRegister.user_birthday.required"
                                >
                                </InputDateTimeNormal>
                            </div>
                            <div class="col-sm-4">
                                <InputTextNormal
                                        :label="dataRegister.user_addr.label"
                                        :id="dataRegister.user_addr.id"
                                        :placeholder="dataRegister.user_addr.placeholder"
                                        :value-default="dataRegister.user_addr.value"
                                        @inputValue="onChange($event, dataRegister.user_addr.id)"
                                        :error-text="dataRegister.user_addr.error"
                                        :is-error="dataRegister.user_addr.isError"
                                        @blur="validateForm($event, dataRegister.user_addr.id)"
                                        :required="dataRegister.user_addr.required"
                                ></InputTextNormal>
                            </div>

                            <div class="col-sm-2 d-flex flex-column justify-content-end">
                                <ButtonSearchComponent :label="labelButtonSetting" @click="registerEmployer"></ButtonSearchComponent>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
